import axios from "axios";

const importWinners = async ({ file_path, luckyDrawUuid, prizeId }) => {
  const body = {
    file_path,
    lucky_draw_uuid: luckyDrawUuid,
    prize_id: prizeId,
  };

  return new Promise((resolve, reject) => {
    axios
      .post(`/campaignV2/customer/luckyDraw/winnerImport`, body)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
};

export default importWinners; 